// Autogenerated file
export const platformNewsItemFlagsEnum = {
    None: "None",
    Visible: "Visible",
};
export const platformNewsItemFlags = [
    { label: "Без опций", value: "None", intValue: 0 },
    { label: "Видимая", value: "Visible", intValue: 1 },
];
